var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("v-text-field", {
        attrs: {
          "hide-details": _vm.hideDetails,
          autofocus: _vm.autofocus,
          "error-messages": _vm.errorMessages,
          label: _vm.label,
          disabled:
            _vm.disabled ||
            (_vm.code &&
              !_vm.user &&
              !_vm.user.is_master &&
              !_vm.user &&
              !_vm.user.is_internal),
          readonly:
            _vm.readonly ||
            (_vm.code &&
              !_vm.user &&
              !_vm.user.is_master &&
              !_vm.user &&
              !_vm.user.is_internal),
        },
        scopedSlots: _vm._u([
          {
            key: "append",
            fn: function () {
              return [
                _vm.code || _vm.textHelper
                  ? _c("emc-info-help", {
                      attrs: {
                        "icon-color": _vm.code ? "error" : "indigo",
                        title: "Informações",
                        text: _vm.textHelper
                          ? _vm.textHelper
                          : "Código externo utilizado para integração com outros sistemas. É permitido alteração apenas pelo administrador.",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }